'use client';

// useSearchParams() forces this page off the static-render path — keep dynamic.
export const dynamic = 'force-dynamic';

import { useSearchParams } from 'next/navigation';

import { LoginFormChakra } from '@/components/auth/login-form-chakra';

export default function LoginPage() {
  const searchParams = useSearchParams();
  const returnUrl = searchParams.get('returnUrl');

  return <LoginFormChakra returnUrl={returnUrl} />;
}
